__webpack_require__.p = "https://home-mind.scalable.care/";